module.exports = __webpack_public_path__ + "ba3ee8a4415322841f8aabd2fa99921a.MP3";